<template>
  <div class="embed-root">
    <slot />
  </div>
</template>

<script setup lang="ts">
// Layout du widget de don embarqué (iframe cross-site) — encore plus dépouillé
// que `payment` : fond transparent pour se fondre dans la page hôte, aucune
// marge/hauteur imposée (la hauteur est mesurée puis poussée à l'hôte pour
// l'auto-resize). Pas de navbar, pas de footer.
</script>

<style>
/* Fond transparent : l'iframe adopte le fond du site hôte quand la page de don
   ne force pas sa propre backgroundColor. */
.embed-root {
  background: transparent;
}
</style>
